export class Product{
    private _id: any;
    private _sku: string;
    private _price: number; 
    private _name: string;
    constructor(id: any, sku: string, price: number, name: string){
        this._id = id;
        this._sku = sku;
        this._price = typeof price == "string" ? parseFloat(price) : price;
        this._name = name;
    }

    
    public get id() : any {
        return this._id;
    }
    
    
    public get sku() : string {
        return this._sku;
    }
    
    public get price() : number {
        return this._price;
    }
    
    public get name() : string {
        return this._name;
    }
    
    
    
}